import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://mqugtyiztrhmujqyldvd.supabase.co'
const supabaseAnonKey = 'sb_publishable_wOJbhonUGIQmLjWqbR7ALg_JhfrIjpF'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)